import Rule from '../Rule';

type SplitBlockHeaderProps = {
    children: React.ReactNode;
    className?: string;
};

export default function SplitBlockHeader({
    children,
    className = '',
}: SplitBlockHeaderProps) {
    return (
        <>
            <h2 className={`mb-6 ${className}`}>{children}</h2>
            <Rule className='mb-6 w-1/2' />
        </>
    );
}
